import { render, staticRenderFns } from "./ResearchStationProgress.vue?vue&type=template&id=25ba1473&"
import script from "./ResearchStationProgress.vue?vue&type=script&lang=js&"
export * from "./ResearchStationProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports